module.exports = __webpack_public_path__ + "static/img/swfzpt-logo.f60d8f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/appCenter/img/swfzpt-logo.png
// module id = wx7g
// module chunks = 96